import * as ActionConfigurationManager from './config.actions';

export const saveBilling = ActionConfigurationManager.SAVE_BILLING;